import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

import styles from "./ContentTitle.module.scss";

type Props = {
  icon: IconProp;
  title: string;
  subTitle: string;
};

const ContentTitle: React.FC<Props> = ({ icon, title, subTitle }) => {
  return (
    <div className={styles["f-contentTitle"]}>
      <div className={styles["f-contentTitle__icon"]}>
        <FontAwesomeIcon icon={icon} />
      </div>
      <div className={styles["f-contentTitle__text"]}>
        <h2>{title}</h2>
        <p>{subTitle}</p>
      </div>
    </div>
  );
};

export default ContentTitle;
